<div class="color-select-component container">
  <div class="current">
    <div
      class="flex-row gap-8 current-color"
      [ngClass]="{ 'default-bg': mode == 'default' }"
    >
      <ng-container *ngIf="color; else noColorMsg">
        <div
          class="color-sample"
          [ngStyle]="{ 'background-color': resolvedColor }"
        ></div>
        <div [ngSwitch]="mode" class="switch-div">
          <ng-container *ngSwitchCase="'default'">
            <div class="base-input">
              <div class="base-input-inner"></div>
            </div>
            <div class="flex-row space-between" style="flex-grow: 1">
              <nw-editable-text
                [text]="colorLabel"
                [inputWidth]="74"
                (textChanged)="updateColor($event)"
                (click)="$event.stopPropagation()"
                (currentTextValue)="pristineColor = $event"
                [activate]="editActive"
                (isActive)="editActive = $event"
                [dark]="dark"
              ></nw-editable-text>
              <div class="flex-row gap-4">
                <nw-icon
                  *ngIf="!color.startsWith('$')"
                  (click)="saveAsVariable()"
                  type="bookmark"
                  [outlined]="true"
                  [size]="16"
                  [matTooltip]="'Save as variable'"
                ></nw-icon>
                <nw-icon
                  (click)="removeFill()"
                  type="close"
                  [outlined]="true"
                  [size]="16"
                  [matTooltip]="'Delete fill'"
                ></nw-icon>
              </div>
            </div>
          </ng-container>
          <div
            *ngSwitchCase="'variable-selected'"
            class="flex-row space-between w-100"
          >
            <div class="fs-14">{{ color.slice(2) }}</div>
            <nw-icon
              (click)="removeFill()"
              type="close"
              [outlined]="true"
              [size]="16"
              [matTooltip]="'Delete fill'"
            ></nw-icon>
          </div>

          <div *ngSwitchCase="'variable-save'">
            <nw-editable-text
              [text]="'color-name'"
              (textChanged)="updateColor($event)"
              [inputWidth]="120"
              [activate]="true"
              [dark]="dark"
            ></nw-editable-text>
            <nw-icon [type]="'check'" (click)="saveVariable()"></nw-icon>
          </div>
        </div>
      </ng-container>

      <ng-template #noColorMsg>
        <div
          class="fs-11 italic p-4 flex-row space-between align-center w-100 dark-color"
        >
          No {{ label }} is defined
          <nw-icon
            (click)="updateColor('#e6e6e6')"
            type="add"
            [outlined]="true"
            [size]="13"
            class="clickable"
          ></nw-icon>
        </div>
      </ng-template>
    </div>
  </div>

  <div style="position: relative; left: -1px; top: 1px">
    <div
      (colorPickerChange)="updateColor($event)"
      [colorPicker]="resolvedColor"
      [cpAlphaChannel]="'disabled'"
      [cpToggle]="true"
      cpPosition="auto"
      [style.width.px]="0"
      [style.left.px]="-10"
      [style.top.px]="10"
      [cpDisableInput]="true"
      [cpDisabled]="false"
      cpDialogDisplay="inline"
      class="position-relative"
    ></div>
  </div>
  <div
    class="flex-column gap-4 pv-6 options"
    style="padding-top: 8px; margin-bottom: 4px"
  >
    <!-- Project Colors List -->
    <div *ngIf="(projectColorPalette$ | async)?.length" style="width: 100%">
      <div
        *ngFor="let value of projectColorPalette$ | async"
        [ngClass]="{ 'selected-variable': color === '$.' + value.label }"
        class="flex-row gap-6 color-option-container"
        (click)="updateColor('$.' + value.label)"
      >
        <div
          class="color-sample"
          [ngStyle]="{ 'background-color': value.color }"
        ></div>
        <div
          class="color-label fs-14"
          style="white-space: nowrap; color: black"
        >
          {{ value.label }}
        </div>
      </div>
    </div>

    <!-- Delimiter if both lists exist -->
    <ng-container
      *ngIf="
        (projectColorPalette$ | async)?.length &&
        (organizationColorPalette$ | async)?.length
      "
    >
      <div
        style="width: 100%; height: 1px; background: black; margin: 0px"
      ></div>
    </ng-container>

    <!-- Organization Colors List -->
    <div
      *ngIf="(organizationColorPalette$ | async)?.length"
      style="width: 100%"
    >
      <div
        *ngFor="let value of organizationColorPalette$ | async"
        [ngClass]="{ 'selected-variable': color === '$.' + value.label }"
        class="flex-row gap-6 color-option-container"
        (click)="updateColor('$.' + value.label)"
      >
        <div
          class="color-sample"
          [ngStyle]="{ 'background-color': value.color }"
        ></div>
        <div
          class="color-label fs-14"
          style="white-space: nowrap; color: black"
        >
          {{ value.label }}
        </div>
      </div>
    </div>
  </div>
</div>
